import { PropsWithChildren, useState } from 'react'
import { TriangleAlert } from 'lucide-react'
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '@/components/ui/hover-card'
import { Button } from '@/components/ui/button'
import TransferModal from 'app/frontend/base/components/TransferModal'
import ProtectedContent from 'app/frontend/base/components/ProtectedContent'
import Card from 'app/frontend/base/components/Card'
import TeamMemberLink from 'app/frontend/base/components/TeamMemberLink'

type RosterMemberProps = {
  className?: string
  member: wowaudit.TeamMembership
  compact?: boolean
  customSpecDetails?: NonNullable<wowaudit.TeamMembership['specDetails']>[]
}

const RosterMember = ({
  className,
  member,
  compact,
  customSpecDetails,
  children,
}: PropsWithChildren<RosterMemberProps>) => {
  const [transferring, setTransferring] = useState(false)

  return (
    <Card
      className={`inline-flex items-center justify-between ${className ?? ''}`}
    >
      <span
        className={`flex items-center min-w-0 ${compact ? 'gap-1.5' : 'gap-2'}`}
      >
        <TeamMemberLink
          member={member}
          compact={compact}
          customSpecDetails={customSpecDetails}
          withTooltip={true}
        />

        {member.characterReference.gdprStatus !== 'exists' && (
          <HoverCard openDelay={150} closeDelay={150}>
            <HoverCardTrigger>
              <span className='text-destructive-foreground cursor-pointer'>
                <TriangleAlert size={14} />
              </span>
            </HoverCardTrigger>
            <HoverCardContent className='text-center'>
              <p>This character is not available in Blizzard&apos;s API</p>
              <ProtectedContent
                section='roster'
                requirement='admin'
                renderUnauthorized={false}
              >
                <Button
                  className='mt-3'
                  variant='secondary'
                  size='sm'
                  onClick={() => setTransferring(true)}
                >
                  Transfer
                </Button>
              </ProtectedContent>
            </HoverCardContent>
          </HoverCard>
        )}

        {transferring && (
          <TransferModal
            scope='character'
            entity={member.characterReference}
            setOpen={setTransferring}
          />
        )}
      </span>

      {children}
    </Card>
  )
}

export default RosterMember
